import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Hero con carrusel de VIDEOS (sin imágenes, sin Revolution Slider).
// Cada video se reproduce una vez; al terminar (onEnded) avanza al siguiente y
// la lista hace loop. Flechas y puntos para navegar.
// Coloca los archivos en frontend/public/assets/media/ y agrégalos/ordénalos aquí:
const VIDEOS = [
    '/assets/media/hero_obra_2.mp4',
    '/assets/media/hero-obra.mp4',
];

export default function Slider1() {
    const { t } = useTranslation();
    const [index, setIndex] = useState(0);
    const videoRef = useRef(null);

    const go = useCallback((step) => {
        setIndex((i) => (i + step + VIDEOS.length) % VIDEOS.length);
    }, []);

    // Cambia la fuente de forma imperativa y reproduce muteado. Es el método más
    // fiable para conmutar el src de un <video> (más que cambiar el atributo en JSX).
    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        v.src = process.env.PUBLIC_URL + VIDEOS[index];
        v.muted = true;          // React no siempre refleja el atributo a la propiedad
        v.load();
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {}); // evita "play() interrupted by pause()"
    }, [index]);

    return (
        <div
            className="home-rev-slider"
            style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden', backgroundColor: '#0c0c0c' }}
        >
            {/* Video activo. SIN loop: al terminar dispara onEnded → siguiente. */}
            <video
                ref={videoRef}
                muted
                playsInline
                onEnded={() => go(1)}
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}
            />

            {/* Capa oscura para legibilidad */}
            <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 1 }} />

            {/* Texto del hero (arriba a la izquierda) */}
            <div
                style={{
                    position: 'relative', zIndex: 2, height: '100%',
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
                    padding: '16vh 8% 0', color: '#fff', fontFamily: '"Poppins", sans-serif',
                    pointerEvents: 'none',  // que no bloquee los clics de flechas/puntos
                }}
            >
                <div style={{ fontWeight: 500, letterSpacing: 10, textTransform: 'uppercase', fontSize: 'clamp(14px, 1.6vw, 22px)', marginBottom: 16 }}>
                    {t('pages.home.hero.tagline')}
                </div>
                <h1 style={{ fontWeight: 800, color: '#fff', fontSize: 'clamp(34px, 6vw, 64px)', lineHeight: 1.1, margin: 0 }}>
                    {t('pages.home.hero.title')}
                </h1>

                {/* left side social bar */}
                <div className="slide-left-social" style={{ position: 'absolute', left: '8%', bottom: 40, pointerEvents: 'auto' }}>
                    <ul className="clearfix">
                        <li><a href="https://www.instagram.com" target="_blank" rel="noreferrer" className="sx-title-swip" data-hover="Instagram">Instagram</a></li>
                        <li><a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="sx-title-swip" data-hover="Facebook">Facebook</a></li>
                        <li><a href="https://linkedin.com" target="_blank" rel="noreferrer" className="sx-title-swip" data-hover="linkedin">LinkedIn</a></li>
                    </ul>
                </div>
            </div>

            {/* Puntos indicadores (clic para saltar a un video) */}
            {VIDEOS.length > 1 && (
                <div style={{ position: 'absolute', bottom: 28, left: '50%', transform: 'translateX(-50%)', zIndex: 5, display: 'flex', gap: 10 }}>
                    {VIDEOS.map((_, i) => (
                        <button
                            key={i}
                            type="button"
                            aria-label={`Video ${i + 1}`}
                            onClick={() => setIndex(i)}
                            style={{
                                width: 12, height: 12, borderRadius: '50%', border: 'none', cursor: 'pointer', padding: 0,
                                background: i === index ? '#fff' : 'rgba(255,255,255,0.4)',
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
